export const FETCH_CUSTOMER_QUOTATION = 'FETCH_CUSTOMER_QUOTATION';
export const QUOTATION_RETRIEVED = 'QUOTATION_RETRIEVED';
export const QUOTATION_DATA_TERMINATE_LOADING = 'QUOTATION_DATA_TERMINATE_LOADING';

export function quotationDataTerminateLoading(quotation) {
  return {
    type: QUOTATION_DATA_TERMINATE_LOADING,
    quotation,
  };
}

export function fetchCustomerQuotation(opportunityId) {
  return {
    type: FETCH_CUSTOMER_QUOTATION,
    opportunityId,
  };
}



// WEBPACK FOOTER //
// ./src/services/SFQuotationService/actions.js